import React, { useState, useEffect, useContext, useCallback } from 'react';
import {Stack, DropZone, Thumbnail, Text, Checkbox as CheckboxPolaris, FormLayout} from '@shopify/polaris';
import {FormProvider} from '@thinkwell/react.common';
import {EditForm, EditModal, TextField, Checkbox} from '@thinkwell/react.polaris';
import {ContentsContext} from '../contexts/Contents'
import {NoteMinor} from '@shopify/polaris-icons';
import EditTags from '../EditTags'
import EditContentForm from './EditContentForm'

export default function EditContent(props) {
  const [contents, fetchContents, fetchContentsState, upsertContent] = useContext(ContentsContext)
  const [file, setFile] = useState();
  const [useFilename, setUseFilename] = useState(false);

  const item = props.item || {}

  const data = {data: item}
  data.data.type = props.type

  const onEditSave = (response) => {
    setFile(null)
    setUseFilename(false)
    props.onSave && props.onSave(response)
    upsertContent(response)
  }

  const url = `/content${item.id ? `/${item.id}` : ''}.json`
  return (
    <FormProvider data={data} omit={['tags']} rootName="content">
      { props.useModal ?
        <EditModal
        active={props.active}
        onActive={props.onActive}
        onSave={onEditSave}
        url={url}
        method={item.id ? 'put' : 'post'}
        linkText={props.linkText}
        title={item.id ? "Edit Content" : "Add Content"}>
        <EditContentForm type={props.type} />
      </EditModal> :
      <EditForm
        active={props.active}
        onActive={props.onActive}
        onSave={onEditSave}
        url={url}
        method={item.id ? 'put' : 'post'}
        linkText={props.linkText}
        title={item.id ? "Edit Content" : "Add Content"}>
        <EditContentForm type={props.type} />
      </EditForm>
      }
    </FormProvider>
  );
}
